import { createContext, useContext, useEffect, useState } from "react";
import { computeCart } from "@/lib/format";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "orse_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, size = null) => {
    const uid = product.id + "#" + (size || "");
    setItems((prev) => {
      const existing = prev.find((i) => (i.uid || i.product.id) === uid);
      if (existing) {
        return prev.map((i) => ((i.uid || i.product.id) === uid ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [...prev, { uid, product, quantity: qty, size: size || null }];
    });
  };

  const setQty = (uid, qty) => {
    setItems((prev) =>
      prev
        .map((i) => ((i.uid || i.product.id) === uid ? { ...i, quantity: Math.max(1, qty) } : i))
        .filter((i) => i.quantity > 0)
    );
  };

  const remove = (uid) =>
    setItems((prev) => prev.filter((i) => (i.uid || i.product.id) !== uid));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const summary = computeCart(items);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, summary }}>
      {children}
    </CartContext.Provider>
  );
}
